import React from 'react'
import LottiePlayer from "lottie-react";
import NoDataFound from '../../../uno/assets/img/nodatafound.json';

const NoDataFound1 = ({ heading }) => {
    return (
        <>
            <div className="no-data-found text-center mt-2">
                <div className="textdata">
                    <LottiePlayer animationData={NoDataFound} style={{ height: 150, marginBottom: 0 }} />
                    <h5 style={{ marginTop: '-10px' }}>{heading}</h5>
                </div>
            </div>
        </>
    )
}

export default NoDataFound1
